module.exports = __webpack_public_path__ + "img/taxi.0e9f8f31.png";